export const BrandNameEnum = {
  shipstationCarrierServices: 'ShipStationCarrierServices',
  oneBalance: 'OneBalance',
};

const enumToStringMap = {
  [BrandNameEnum.shipstationCarrierServices]: 'ShipStation Carrier Services',
  [BrandNameEnum.oneBalance]: 'One Balance\u2122',
};

export const getDisplayStringFromEnum = (brandName) => {
  return enumToStringMap[brandName] || enumToStringMap[BrandNameEnum.shipstationCarrierServices];
};
